import React, { Component, PropTypes } from 'react';
import shouldPureComponentUpdate from 'react-pure-render/function';

import LinkButton from 'components/LinkButton/LinkButton';

import './DuplicateNamesModal.desktop.scss';
import './DuplicateNamesModal.mobile.scss';

export default class DuplicateNamesModal extends Component {
  static propTypes = {
    onContinue: PropTypes.func.isRequired,
    onGoBack: PropTypes.func.isRequired,
  };
  shouldComponentUpdate = shouldPureComponentUpdate;

  goBack = (e) => {
    e.preventDefault();
    this.props.onGoBack();
  }
  continueSubmit = (e) => {
    e.preventDefault();
    this.props.onContinue();
  }
  render() {
    return (
      <div className="duplicate-names-modal">
        <span>There seem to be duplicate information on the details that you have provided. Please revisit all the passengers' details and make sure all the information is correct before proceeding.</span>
        <div className="duplicate-names-modal__buttons-container">
          <div className="duplicate-names-modal__buttons-container__button-secondary">
            <LinkButton onClick={this.goBack} type="secondary" color="blue">Back to details</LinkButton>
          </div>
          <div className="duplicate-names-modal__buttons-container__button-primary">
            <LinkButton onClick={this.continueSubmit} type="primary" color="blue">Continue booking</LinkButton>
          </div>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/DuplicateNamesModal/DuplicateNamesModal.jsx
 **/